<template>
    <div class="contact-wrapper">
        <div class="container">
            <div class="row">
                <div class="col">
                    <h2 class="contact-h2">Gegevens</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-6 col-xl-7">
                    <p class="text-white pr-5">Vul hier jouw persoonlijke gegevens in en wij sturen je onze vrijblijvende offerte!</p>
                    <b-form @submit="onSubmit" class="form_contact" @reset="onReset" v-if="show">
                        <b-form-row>
                            <b-col class="col-right-padding col-12 col-sm-6">
                                <b-form-group id="input-group-2">
                                    <b-form-input
                                        id="input-lastname"
                                        v-model="form.lastname"
                                        required
                                        placeholder="NAAM"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col class="col-12 col-sm-6">
                                <b-form-group id="input-group-1">
                                    <b-form-input
                                        id="input-firstname"
                                        v-model="form.firstname"
                                        required
                                        placeholder="VOORNAAM"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                        <b-form-row>
                            <b-col>
                                <b-form-group id="input-group-3">
                                    <b-form-input
                                        id="input-street"
                                        v-model="form.street_no"
                                        required
                                        placeholder="STRAAT + NR"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                        <b-form-row>
                            <b-col class="col-right-padding col-12 col-sm-6">
                                <b-form-group id="input-group-6">
                                    <b-form-input
                                        id="input-zip"
                                        v-model="form.zip"
                                        required
                                        placeholder="POSTCODE"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col class="col-12 col-sm-6">
                                <b-form-group id="input-group-7">
                                    <b-form-input
                                        id="input-city"
                                        v-model="form.city"
                                        placeholder="GEMEENTE"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                        <b-form-row>
                            <b-col class="col-right-padding col-12 col-sm-6">
                                <b-form-group id="input-group-7">
                                    <b-form-input
                                        id="input-phone"
                                        v-model="form.phone"
                                        required
                                        placeholder="TELEFOONNUMMER"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col class="col-12 col-sm-6">
                                <b-form-group id="input-group-6">
                                    <b-form-input
                                        id="input-email"
                                        v-model="form.email"
                                        type="email"
                                        required
                                        placeholder="E-MAIL"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                        <b-form-row>
                            <b-col>
                                <b-form-group id="input-group-6">
                                    <b-form-input
                                        id="input-vat"
                                        v-model="form.vat"
                                        type="text"
                                        required
                                        placeholder="BTW NUMMER"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-form-row>



                        <b-button type="submit" variant="primary" id="btn-submit">Offerte genereren</b-button>
                    </b-form>
                </div>
                <div class="col-lg-1 d-none d-lg-flex d-xl-none"></div>
                <div class="col-12 col-lg-5 right_static">
                    <div>
                        <h4>Hebt u een vraag?</h4>
                        <h4>Wij helpen u graag!</h4><br>
                        <p><strong>U kunt ons steeds bereiken op:</strong></p>
                        <ul>
                            <li><a href="tel:033037900">03 303 79 00</a></li>
                            <li><a href="tel:011494333">011 49 43 33</a></li>
                            <li><span>nu open</span></li>
                        </ul>
                        <p><strong>Mailen</strong> kan naar&nbsp;<a href="mailto:info@straalstudio.be">info@straalstudio.be</a></p>

                        <p>Heeft u nog andere vragen? <br><strong><a href="https://straalstudio.be/contact" target="_blank">Stel ze hier</a> !</strong></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ajax from '../ajax';

    export default {
        name: "Contact",

        props: ['id'],

        data() {
            return {
                form: {
                    lastname: 'Kennes',
                    firstname: 'Ward',
                    street_no: 'Binnenweg 34 A',
                    zip: '2800',
                    city: 'Mechelen',
                    phone: '09 488 66 55',
                    email: 'ward@ldl.be',
                    vat:'BE065656565',
                    privacy: '1'
                },
                show: true,
                order: null
            }
        },

        methods: {
            onSubmit(evt) {
                evt.preventDefault()
                console.log('Stap 1');
                // alert(JSON.stringify(this.form))
                this.$root.$emit('update-processing', true);
                //console.log(JSON.stringify(this.form));
                console.log('Stap 2');
                ajax.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
                ajax.post('/api/v1/register', {
                    'form' : this.$data.form,
                    'products': this.$data.order
                }).then((response) => {
                    this.$root.$emit('update-processing', false);
                    sessionStorage.setItem('flashMessage', 'form-success');

                    // Reset localstorage...
                    localStorage.clear();

                    // Move to the startpage on success:
                    if (response.data.status == 200) {
                        setTimeout(() => {
                            this.$router.push({ name: 'categories'})
                        }, 2000);
                    }
                console.log('Stap 3');

                    // Go back to the overview.
                }).catch(function(error) {
                    console.log(error);
                });
            },
            onReset(evt) {
                evt.preventDefault()
                // Reset our form values
                this.form.email = ''
                this.form.name = ''
                this.form.food = null
                this.form.checked = []
                // Trick to reset/clear native browser form validation state
                this.show = false
                this.$nextTick(() => {
                    this.show = true
                })
            }
        },

        mounted: function () {
            this.$data.order = JSON.parse(localStorage.getItem('products'));
        }
    }
</script>

<style scoped lang="scss">

    .contact-h2 {
        font-size: 1.7rem;
        margin-bottom: 20px;
        text-align: center;
        font-weight: 500;
        @media (min-width: 992px) {
            font-size: 2rem;
            text-align: left;
        }
        @media (min-width: 1200px) {
            font-size: 2.4rem;
        }
    }

    .contact-wrapper {
        padding: 15px;
    }

    .form_contact {
        input {
            background: none;
            border: none;
        }
        
        @media (min-width: 576px){
            .form-row > .col-right-padding {
                padding-right: 30px;
            }
        }

        .form-group {
            border-bottom: 1px solid #FFFFFF;
        }

        .form-control {
            padding: 0;
            color: white;
            &:focus {
                outline: 0;
                box-shadow: none;
            }
            &::placeholder {
                color: rgb(235,235,235);
                font-weight: 300;
            }
        }
    }

    #btn-submit {
        display: block;
        width: 100%;
        margin-top: 20px;
        padding: 20px 30px;
        @media (min-width: 768px){
            width: auto;
        }
    }

    .right_static {
        color: white;
        margin-top: 60px;
        @media (min-width: 992px){
            margin-top: 0;
        }
        @media (min-width: 1201px){
            position: absolute;
            right: 0;
            width: 350px;
        }
        @media (min-width: 1400px){
            position: absolute;
            right: -100px;
        }
        h4 {
            text-transform: uppercase;
        }
        p {
            font-weight: 300;
        }
        ul {
            margin: 0;
            margin-bottom: 1rem;
            padding: 0;
            list-style: none;
            li {
                font-weight: 300;
                a, a:hover {
                    text-decoration: none;
                }
                span {
                    background: white;
                    margin-top: 5px;
                    padding: 4px 10px;
                    display: inline-block;
                    color: black;
                }
            }
        }
        a {
            color: white;
        }
    }
</style>

